import React from "react";
import SearchFilters from "./SearchFilters";
import FlexBox from "../../../elements/v2/Box/FlexBox";
import Box from "../../../elements/v2/Box/Box";
import { useSearchPageContext } from "../SearchPageContext";
import ActiveRefinements from "../../../../utils/algolia/ActiveRefinements";
import Pagination from "../../../../utils/algolia/Pagination";
import Hits from "../../../../utils/algolia/Hits";

export default function SearchContent() {
  const { longTailPage } = useSearchPageContext();

  return (
    <FlexBox p={1}>
      {!longTailPage && <SearchFilters />}
      <Box flexGrow={1}>
        <ActiveRefinements />
        <Hits />
        {!longTailPage && <Pagination />}
      </Box>
    </FlexBox>
  );
}
